import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.sendHeightToParent()
    this.setupResizeObserver()
  }

  disconnect() {
    if (this.resizeObserver) this.resizeObserver.disconnect()
  }

  sendHeightToParent() {
    const height = document.body.scrollHeight;
    const buffer = 20

    window.parent.postMessage({
      type: 'resize',
      height: height + buffer
    }, '*')
  }

  // Set up observer to watch for content changes
  // Works when the body resizes (content added/removed, elements expanded/collapsed)
  setupResizeObserver() {
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        this.sendHeightToParent()
      })
      
      // Observe the document body for size changes
      this.resizeObserver.observe(document.body)
    } else {
      // Fallback for browsers that don't support ResizeObserver
      window.addEventListener('resize', () => {
        this.sendHeightToParent()
      })
    }
  }

  // Send message to parent iframe
  sendToIframe(event) {
    event.preventDefault()
    
    const { messageType, params } = event.currentTarget.dataset
    if (!messageType || !params) return
    
    window.parent.postMessage({
      type: messageType,
      params: params,
    }, '*')
  }
}
